(function () {

    // Initialize ClickDimensions page analytics and set the cuvid visitor cookie.
    // The form POST (gform_3 → ClickDimensions) is handled server-side via gform_after_submission;
    // this script exists solely for visitor tracking and CRM attribution.
    function initCDAnalytics() {
        if (typeof clickdimensions === 'undefined' || typeof clickdimensions.Analytics === 'undefined') {
            setTimeout(initCDAnalytics, 100);
            return;
        }

        var cdAnalytics = new clickdimensions.Analytics('analytics.clickdimensions.com');
        cdAnalytics.setAccountKey('a7R8PXNvEEWrD8iEn3cknA');
        cdAnalytics.setDomain('captrustadvisors.com');
        cdAnalytics.setScore(typeof cdScore === 'undefined' ? 0 : (cdScore === 0 ? null : cdScore));
        cdAnalytics.trackPage();
    }

    initCDAnalytics();

}());
